import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getGroupsAction } from "../actions/get-groups.action";
import { GroupsState } from "domain/groups/entities/interfaces/groups-state.interface";
import { sortDataByAlphabet } from "app/data/helpers";

const getGroupsCases = (builder: ActionReducerMapBuilder<GroupsState>) => {
  builder.addCase(getGroupsAction.pending, (state) => {
    state.isLoadingGroups = true;
  });
  builder.addCase(getGroupsAction.fulfilled, (state, action) => {
    state.groups = sortDataByAlphabet(action?.payload, "name");
    state.isLoadingGroups = false;
  });
  builder.addCase(getGroupsAction.rejected, (state) => {
    state.isLoadingGroups = false;
  });
};

export default getGroupsCases;
